const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'cart',
        component: () => import(/* webpackChunkName: "b2b_cart" */ '@/pages/cart/CartPage.vue'),
        meta: {
          title: '购物车'
        },
        path: '/cart'
      },
      {
        name: 'aibuy',
        component: () => import(/* webpackChunkName: "ai_buy" */ '@/pages/cart/aiBuy/index'),
        meta: {
          title: '智能采购'
        },
        path: '/aibuy'
      }
    ]
  }
];
